import { render, staticRenderFns } from "./AlertsPanel.global.vue?vue&type=template&id=07a1ad38&lang=pug&"
import script from "./AlertsPanel.global.vue?vue&type=script&lang=ts&"
export * from "./AlertsPanel.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports